import { render, staticRenderFns } from "./ParkingSpaceListItem.vue?vue&type=template&id=fd1fae3a&scoped=true&"
import script from "./ParkingSpaceListItem.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceListItem.vue?vue&type=script&lang=js&"
import style0 from "./ParkingSpaceListItem.vue?vue&type=style&index=0&id=fd1fae3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1fae3a",
  null
  
)

export default component.exports